<template>
  <!-- 基本信息 -->
  <div>
    <div class="org-detail">
      <Entdetail v-if="status==0" :dataEnt="dataEnt"></Entdetail>
      <Parkdetail v-if="status==2" :dataPark="dataPark"></Parkdetail>
      <Wtdetail v-if="status==3" :dataWt="dataWt"></Wtdetail>
      <Govdetail v-if="status==1" :dataGov="dataGov"></Govdetail>
      <Otherdetail v-if="status==4" :dataOther="dataOther"></Otherdetail>
    </div>
    <div class="org-control">
      <el-button type="warning" @click="confirm" style="width:100px;margin-top:20px">修改</el-button>
    </div>
  </div>
</template>
<script>
import Entdetail from '../../components/plan/Entdetail.vue'
import Govdetail from '../../components/plan/Govdetail.vue'
import Otherdetail from '../../components/plan/Otherdetail.vue'
import Parkdetail from '../../components/plan/Parkdetail.vue'
import Wtdetail from '../../components/plan/Wtdetail.vue'
import company from '../../data/basic/plan/company.js'
import usermember from '../../data/basic/plan/usermember.js'
import { mapState, mapMutations } from 'vuex'
import moment from 'moment'

export default {
  data() {
    return {
      // 显示权限
      status: 0,
      dataEnt: null,
      dataPark: {},
      dataWt: {},
      dataGov: {},
      dataOther: {},
      dataOthers: {},
      datagovs: {},
      tableData: [],
    }
  },
  computed: {
    ...mapState({
      valbody(state) {
        return state.valbody
      }
    })
  },
  created() {
    // 执行状态控制方法
    this.status = sessionStorage.orgStatus
    this.getOrgDetail()
  },
  methods: {
    ...mapMutations(['dataGovForm']),
    // 点击
    confirm() {
      this.$router.push('/editunit')
    },
    // 获取申报单位详情
    getOrgDetail() {
      switch (JSON.parse(sessionStorage.orgStatus)) {
        case 0:
          this.detail_entp()
          break;
        case 1:
          this.detail_gov()
          break;
        case 2:
          this.detail_zone()
          break;
        case 3:
          this.detail_water()
          break;
        case 4:
          this.detail_other()
          break;
      }
    },
    // 其他详情
    detail_other() {
      (async() => {
        let dataOthers = await company.detail_other({
          id: sessionStorage.currenOrgId,
        })
        if (dataOthers.status) {
          this.dataOther = this.allDetails = dataOthers.data
          // if (dataOthers.data.id) {
          //   this.getUser({
          //     subjectIds: dataOthers.data.id
          //   })
          // } else {
          //   this.$message.error('获取申报单位详情失败')
          // }
        } else {
          this.$message.error('获取申报单位详情失败')
        }
      })()
    },
    // 政府详情
    detail_gov() {
      (async() => {
        let datagovs = await company.detail_gov({
          id: sessionStorage.currenOrgId,
        })
        if (datagovs.status) {
          this.dataGov = this.allDetails = datagovs.data
        } else {
          this.$message.error('获取申报单位详情失败')
        }
      })()
    },
    // 企业详情
    detail_entp() {
      (async() => {
        let dataents = await company.detail_entp({
          id:sessionStorage.currenOrgId,
        })
        if (dataents.status) {
          this.dataEnt = this.allDetails = dataents.data
        } else {
          this.$message.error('获取申报单位详情失败')
        }
      })()
    },
    // 工业园区详情
    detail_zone() {
      (async() => {
        let datazone = await company.detail_zone({
          id: sessionStorage.currenOrgId,
        })
        if (datazone.status) {
          this.dataPark = this.allDetails = datazone.data
        } else {
          this.$message.error('获取申报单位详情失败')
        }
      })()
    },
    // 水源地详情
    detail_water() {
      (async() => {
        let datawts = await company.detail_water({
          id: sessionStorage.currenOrgId,
        })
        if (datawts.status) {
          this.dataWt = this.allDetails = datawts.data
        } else {
          this.$message.error('获取申报单位详情失败')
        }
      })()
    },

  },
  components: {
    Entdetail,
    Govdetail,
    Otherdetail,
    Parkdetail,
    Wtdetail
  }
}

</script>
<style lang="stylus" scoped>
.org-control {
  margin-left: 158px;
  margin-bottom: 100px;
}

.gov-p {
  margin-bottom: 15px
}

.org-p1 {
  margin-left: 15px;
}

.el-select {
  width: 300px;
}

.p-color1 {
  color: #000;
  font-size: 16px;
}

.p-color2 {
  margin-top: 20px;
  color: #ccc;
  font-size: 12px;
}

</style>



// WEBPACK FOOTER //
// informa.vue?3b87bb88